export default __webpack_public_path__ + "static/media/laptop.89edde97.jpeg";